import PropertyStatus from 'scripts/constants/PropertyStatus';

const MarketClosedFlag = ({ propertyStatus }) => {
  if (propertyStatus !== PropertyStatus.VOTE_CLOSED && propertyStatus !== PropertyStatus.VOTE_OPEN) {
    return null;
  }

  return (
    <div className="property-card-flag property-card-flag--new-property" data-test-reference="market_closed_flag">
      <div className="property-card-flag--emphasized-text-md">
        {propertyStatus === PropertyStatus.VOTE_CLOSED ? 'LIVE' : 'VOTE'}
        <br/>
        {propertyStatus === PropertyStatus.VOTE_CLOSED ? 'SALE' : 'OPEN'}
      </div>
    </div>
  );
};

export default MarketClosedFlag;
